import { useMemo } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { LoyaltyApi } from "@jti/rest-api";

export const useLoyaltyApi = () => {
  const config = useConfig();
  return useMemo(() => LoyaltyApi.init(config), [config]);
};
